// extracted by mini-css-extract-plugin
export default {"kpiCard":"styles_kpiCard__Vtl7W","wrapper":"styles_wrapper__GCykV","pIcon":"styles_pIcon__9Vinu","pLabel":"styles_pLabel__02em1"};